import { render } from "./layout-rtl.vue?vue&type=template&id=68b64d6c&scoped=true"
import script from "./layout-rtl.vue?vue&type=script&lang=js"
export * from "./layout-rtl.vue?vue&type=script&lang=js"

import "./layout-rtl.vue?vue&type=style&index=0&id=68b64d6c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b64d6c"]])

export default __exports__